import React from "react";

interface IWCUComponentProps {
    title: string;
    subTitle: string;
    icon: string;
    delay: string;
}

export const WCUComponent: React.FC<IWCUComponentProps> = (
    props: IWCUComponentProps
) => {
    const { title, subTitle, icon, delay } = props;

    return (
        <div
            className="col-lg-4 col-md-12"
            data-aos="fade-up"
            data-aos-delay={delay}
        >
            <div className="stats-item text-center w-100 h-100">
                <span
                    data-purecounter-start="0"
                    data-purecounter-end="232"
                    data-purecounter-duration="1"
                    className="purecounter"
                ></span>
                <i
                    className={`bi bi-${icon} flex-shrink-0`}
                    style={{ fontSize: "50px" }}
                />
                <h5 className="subheading">{title}</h5>
                <p style={{ fontSize: "14px" }}>{subTitle}</p>
            </div>
        </div>
    );
};
